import React from "react";
import BlankLayout from "./BlankLayout";

import GlobalContextProvider from "../../Contexts/GlobalContextProvider";

const Content = (props) => {
  return (
    <>
      <GlobalContextProvider>
        <BlankLayout
          parentName={props.parentName}
          parentRoute={props.parentRoute}
          currentName={props.currentName}
          publicRoute={props.publicRoute}
        >
          {props.children}
        </BlankLayout>
      </GlobalContextProvider>
    </>
  );
};

export default Content;
